import { Notify } from "notiflix";
import authService from "../../services/AuthService";
import { buildCQLFilter } from "../../services/MapCore/MapCQLFilterService";
import { findLayerById } from "../../services/MapCore/LayerGroupService";
import { Divider } from "@mui/material";

class LayerGroupSettings {
  constructor(map, layer_group_data) {
    // console.log("LayerGroupSettings constructor", layer_group_data);
    this.layer_group_data = layer_group_data;
    this.id = `layergroup-${layer_group_data?.uuid}`;
    this.name = "";
    this.layers = [];
    // this.legends = [];
    this.visible = true;
    this.map = map;
    // this.getFilter = () => <></>;
    this.has_filter = false;
    this.has_dashboard = false;
    this.dashboard = <></>;
    this.order = 1;
    this.defaultLayer = {
      attribution_html: { en: "", es: "" },
      layer: null,
      id: "layer-",
      layer_group_id: "",
      name: { en: "", es: "" },
      map: false,
      // getChangeStyleComponent: (new_style) => {},
      legend: false,
      styles: [],
      opacity: 1,
      zIndex: 50,
      visible: true,
      onClickGetInfo: null,
      controlSettingsComponent: false,
      description: "",
      display: true,
    };
  }

  createLayers = () => [];

  // Método para agregar una layer
  agregarLayer(id, layer, style, opacity = 1, zIndex = 1, visible = true) {
    this.layers.push({ id, layer, style, zIndex, opacity, visible });
  }

  // Método para eliminar una layer
  eliminarLayer(layer) {
    this.layers = this.layers.filter((c) => c.layer !== layer);
  }

  setLayerVisibility(id, visible) {
    const layer = this.layers.find((layer) => layer.id === id);
    if (layer) {
      layer.visible = visible;
    }
  }

  setLayerOpacity(id, opacity) {
    const layer = this.layers.find((layer) => layer.id === id);
    if (layer) {
      layer.opacity = opacity;
    }
  }

  setLayerZIndex(id, zIndex) {
    const layer = this.layers.find((layer) => layer.id === id);
    if (layer) {
      layer.zIndex = zIndex;
    }
  }

  handleChangeStyle = (ev, layer_id, map) => {
    console.log("LayerGroupSettings handleChangeStyle", this, ev);

    const layer = this.layers.filter(
      (old_layer) => old_layer.id == layer_id
    )[0];

    const new_style_id = ev.target.value;
    const new_style = layer.styles.filter(
      (style) => style.id === new_style_id
    )[0];
    layer.style = new_style;

    const map_layer = findLayerById(map, layer_id);
    map_layer
      .getSource()
      .updateParams({ STYLES: new_style.geoserver_style_id });
  };
}
export default LayerGroupSettings;
